import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetCarouselComponent } from './widget-carousel.component';

@NgModule({
  declarations: [WidgetCarouselComponent],
  imports: [CommonModule],
  exports: [WidgetCarouselComponent]
})
export class WidgetCarouselModule {}
